import styled from '@emotion/native'
import { KeyboardAvoidingView, View } from 'react-native'

export const ModalContainer = styled(View)(({ theme }) => ({
  justifyContent: 'space-between',
  alignContent: 'flex-start',
  backgroundColor: 'white',
  minHeight: '30%',
  maxHeight: '80%',
  borderRadius: 15,
  padding: theme.sizes.md,
}))

export const ModalContainerKeyboardAvoid = styled(KeyboardAvoidingView)(({ theme }) => ({
  justifyContent: 'space-between',
  alignContent: 'flex-start',
  backgroundColor: 'white',
  minHeight: '20%',
  maxHeight: '80%',
  borderRadius: 15,
  padding: theme.sizes.md,
}))
